import {Button} from 'platform/components';
import {Box, Heading, Text, useDevice, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {DocumentExtractionImportSuccessImage} from './DocumentExtractionImportSuccessImage';

interface DocumentExtractionImportSuccessProps extends RequiredTestIdProps {
  onClose: VoidFunction;
}

export function DocumentExtractionImportSuccess(props: DocumentExtractionImportSuccessProps) {
  const device = useDevice();

  const isMobile = device === 'mobile';

  return (
    <Box padding={[0, 6, 6, 6]} data-testid={props['data-testid']}>
      <VStack align="center" justify="center" spacing={4}>
        <DocumentExtractionImportSuccessImage />
        <Heading size={isMobile ? 4 : 3} align="center">
          {i18n.t('entity.documentExtraction.labels.importSuccessful')}
        </Heading>
        <Box>
          <Text size={isMobile ? 'xSmall' : 'base'} align="center" color="secondary">
            {i18n.t('entity.documentExtraction.labels.importSuccessfulInstruction')}
          </Text>
        </Box>
        <Button
          title={i18n.t('general.actions.continue')}
          onClick={props.onClose}
          data-testid={suffixTestId('actions.continue', props)}
        />
      </VStack>
    </Box>
  );
}
